import React from 'react'


class VideoView extends React.Component {

  


  render() {

    return(

      <div>
        

        <div className="container">

          <h1 style={{textAlign: 'center', margin: '60px 0 20px 0', color: '#816992'}}>{this.props.data.name}</h1>

          <div className="video-wrapper" style={{display: 'flex', flexWrap: 'wrap'}}>

            {this.props.data.files.map(file => (
                <div key={file.id} className="video-object" style={{margin: '0 10px 20px 10px'}}>
                    <iframe title={file.id} src={`${this.props.data.embedPath}${file.id}`} width="100%" frameborder="0" allowFullScreen></iframe>
                    
                    <p style={{textAlign: 'center'}}>{file.title}</p>
                </div>
            ))}

          </div>

        </div>

      </div>
    )
  }
}

export default VideoView



// WEBPACK FOOTER //
// ./src/components/VideoView.js